import {gsap} from "gsap";
import App from "../../../templates/src/App/App";

const HeaderImage = {
    textHeight: 140,

    init() {
        this.el = $('[template="HeaderImage"]');
        if (!this.el.length) return;

        this.container = this.el.find('[container]');
        this.text = this.el.find('[element="textarea"]');
        this.resize();
    },

    prepare() {
        this.text.css({height: this.textHeight}).addClass('collapsed');
        this.button = $('<button class="text size24 white mt16" icon="add"></button>')
            .text(window.T.global.more)
            .insertAfter(this.text);

        this.bind();
    },

    bind() {
        this.button.click((evt) => {
            if (this.text.is('.collapsed')) {
                this.text.removeClass('collapsed');
                $(evt.currentTarget).text(window.T.global.less);
                gsap.set(this.text, {height: "auto"});
                gsap.from(this.text, {height: this.textHeight, clearProps: true})
            } else {
                $(evt.currentTarget).text(window.T.global.more);
                gsap.to(this.text, {
                    height: this.textHeight, onComplete: () => {
                        this.text.addClass('collapsed');
                    }
                })
            }
        })
    },

    release() {
        if (!this.text.is('.collapsed')) return;
        this.text.removeClass('collapsed').removeAttr('style');
        this.button.remove();
    },

    resize() {
        if (!this.el.length) return;
        if (App.isMobile) {
            if (this.text.outerHeight() > this.textHeight) this.prepare();
            else this.release();
        } else this.release();
    },

}

export default HeaderImage;